var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "destroy-on-close": true,
        title: _vm.$t("CargoMsg.Cargo_ChargeChange"),
        width: "1300px",
        "before-close": _vm.close
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-bottom": "10px" } },
        [
          !_vm.editable
            ? _c(
                "el-button",
                {
                  attrs: { id: "btnAdd1", type: "primary" },
                  on: { click: _vm.editClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")) + " ")]
              )
            : _vm._e(),
          !_vm.editable
            ? _c(
                "el-button",
                { attrs: { id: "btnDelete1" }, on: { click: _vm.close } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DisableOpen")) + " ")]
              )
            : _vm._e(),
          _vm.editable
            ? _c(
                "el-button",
                {
                  attrs: { id: "btnAdd1", type: "primary" },
                  on: { click: _vm.commitClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")) + " ")]
              )
            : _vm._e(),
          _vm.editable
            ? _c(
                "el-button",
                { attrs: { id: "btnDelete1" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c(
            "cargo-up-down-resize",
            {
              staticClass: "app-main-inner section",
              staticStyle: { height: "100%", "max-height": "800px" },
              attrs: {
                "show-down": _vm.tabSelling.visible,
                "show-up": _vm.tabCost.visible,
                "up-style": {
                  display: "flex",
                  flexDirection: "column",
                  paddingBottom: "5px"
                },
                "down-style": {
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "5px"
                }
              }
            },
            [
              _c(
                "template",
                { slot: "up" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "operations",
                      staticStyle: { "padding-bottom": "5px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "triggers" },
                        [
                          _c(
                            "div",
                            [
                              _c("span", {}, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                              ]),
                              _c("charge-currency-total-group", {
                                ref: "arTotalGroup",
                                attrs: {
                                  no: "arTotalGroup",
                                  "amount-to-currency": _vm.localCurrency,
                                  "data-provider":
                                    _vm.arTotalGroup.dataProvider,
                                  "data-field": _vm.config
                                    ._isCalculateExcludingAmount
                                    ? "amount"
                                    : "excludingTaxAmount",
                                  "rate-field": "exchangeRate",
                                  "is-gross-profit": true,
                                  "show-controlled-profit":
                                    _vm.privilege.showControlledProfit,
                                  "show-cost-controlled":
                                    _vm.privilege.isCostControlled,
                                  type: "ar"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "cargo-button-group-slider",
                            {
                              staticStyle: { flex: "1", border: "none" },
                              attrs: { no: "top", align: "right" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "padding-bottom": "10px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        disabled: !_vm.editable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.copySellingHandler()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_sp6")
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        disabled: !_vm.editable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.chargeSchemeHandler()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_sp7")
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        id: "btnAdd1",
                                        disabled: !_vm.editable,
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.addCost()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_add")
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        id: "btnDelete1",
                                        disabled: !_vm.editable,
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteCost()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_delete")
                                        ) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "filters" })
                    ]
                  ),
                  _c("cargo-ag-grid", {
                    ref: "tabCostGrid",
                    staticStyle: { "flex-grow": "1" },
                    attrs: {
                      "grid-options": _vm.tabCost.grid.gridOptions,
                      "column-defs": _vm.dynamicColumnDefsForCost,
                      "grid-params": _vm.tabCost.grid.gridParams,
                      "config-module": "202304",
                      "row-data": _vm.tabCost.grid.overseaCostDetails
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.tabCost.grid, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.tabCost.grid, "gridParams", $event)
                      },
                      gridReady: _vm.onCostGridReady
                    }
                  })
                ],
                1
              ),
              _c(
                "template",
                { slot: "down" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "operations",
                      staticStyle: {
                        "margin-top": "10px",
                        "padding-bottom": "5px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "triggers" },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                              ]),
                              _c("charge-currency-total-group", {
                                ref: "apTotalGroup",
                                attrs: {
                                  no: "apTotalGroup",
                                  "amount-to-currency": _vm.localCurrency,
                                  "data-provider":
                                    _vm.apTotalGroup.dataProvider,
                                  "data-field": _vm.config
                                    ._isCalculateExcludingAmount
                                    ? "amount"
                                    : "excludingTaxAmount",
                                  "rate-field": "convertRateRmb",
                                  "is-gross-profit": true,
                                  "show-controlled-profit":
                                    _vm.privilege.showControlledProfit,
                                  "show-controlled": _vm.privilege.isControlled,
                                  type: "ap"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "cargo-button-group-slider",
                            {
                              staticStyle: { flex: "1", border: "none" },
                              attrs: { no: "top", align: "right" }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "charge_copyCost",
                                        type: "primary",
                                        disabled: !_vm.editable
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.copyCostHandler(true)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "FinanceManage.charge_copyCost"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        id: "btnAdd2",
                                        disabled: !_vm.editable,
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.addSelling()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_add")
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        id: "btnDelete2",
                                        disabled: !_vm.editable,
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSelling()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("FinanceManage.charge_delete")
                                        ) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "filters" })
                    ]
                  ),
                  _c("cargo-ag-grid", {
                    ref: "tabSellingGrid",
                    staticStyle: { "flex-grow": "1" },
                    attrs: {
                      "grid-options": _vm.tabSelling.grid.gridOptions,
                      "grid-params": _vm.tabSelling.grid.gridParams,
                      "column-defs": _vm.dynamicColumnDefsForSelling,
                      "config-module": "202305",
                      "row-data": _vm.tabSelling.grid.overseaSellingDetails
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(
                          _vm.tabSelling.grid,
                          "gridParams",
                          $event
                        )
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(
                          _vm.tabSelling.grid,
                          "gridParams",
                          $event
                        )
                      },
                      gridReady: _vm.onSellingGridReady
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: " operations",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("div", { staticClass: "filters" }),
                      _c("div", { staticClass: "triggers" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                              width: "100%"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Profit"))
                                      )
                                    ]),
                                    _c("charge-currency-total-group", {
                                      attrs: {
                                        no: "profit",
                                        "amount-to-currency": _vm.localCurrency,
                                        "data-field": _vm.config
                                          ._isCalculateExcludingAmount
                                          ? "amount"
                                          : "excludingTaxAmount",
                                        "rate-field": "convertRateRmb",
                                        "data-provider":
                                          _vm.revenueTotalGroup.dataProvider,
                                        "is-gross-profit": true,
                                        "show-controlled-profit":
                                          _vm.privilege.showControlledProfit,
                                        "show-controlled":
                                          _vm.privilege.isControlled,
                                        type: "revenue",
                                        "show-cost-controlled":
                                          _vm.privilege.isCostControlled
                                      }
                                    }),
                                    _vm.config.showGrossProfit
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_GrossMargin"
                                              )
                                            ) + ": "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.config.showGrossProfit
                                      ? _c("charge-gross-margin", {
                                          attrs: {
                                            "data-field": _vm.config
                                              ._isCalculateExcludingAmount
                                              ? "amount"
                                              : "excludingTaxAmount",
                                            "data-provider":
                                              _vm.revenueTotalGroup.dataProvider
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-left": "10px" } },
                                  [
                                    _c("el-checkbox", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.checkbox.chkInternal.visible,
                                          expression:
                                            "checkbox.chkInternal.visible"
                                        }
                                      ],
                                      attrs: {
                                        id: "chkInternal",
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_ShowInternalCharges"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.chkInternalChargeHandler(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.checkbox.chkInternal.selected,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.checkbox.chkInternal,
                                            "selected",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "checkbox.chkInternal.selected"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm.workFlowApplyDialog.visible
        ? _c("charge-apply-dialog", {
            ref: "workFlowApplyDialog",
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              "change-charge": _vm.workFlowApplyDialog.changeCharge,
              title: _vm.$t("CargoMsg.Cargo_ApprovalProcessForChargeChange"),
              type: "apply"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: _vm.closeAndRefresh
            }
          })
        : _vm._e(),
      _c("charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "original-condition": _vm.chargePlanDialog.originalCondition,
          "charge-scheme-is-approved":
            _vm.chargePlanDialog.chargeSchemeIsApproved,
          source: _vm.chargePlanDialog.source,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: function(schemeDetails) {
            _vm.selectedSchemeHandler(schemeDetails)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }